import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import {
  BlockedRecordProctorSchema,
  type BlockedRecordProctorFormInput,
} from './blocked-record-proctor-form-schema';

interface BlockedRecordProctorFormProviderProps extends PropsWithChildren {
  initialValues?: BlockedRecordProctorFormInput;
}

export default function BlockedRecordProctorFormProvider(
  props: Readonly<BlockedRecordProctorFormProviderProps>,
) {
  const { children, initialValues } = props;

  const formContext = useForm<BlockedRecordProctorFormInput>({
    resolver: zodResolver(BlockedRecordProctorSchema),
    defaultValues: initialValues,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
